import React from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  OportunidadeModalProvider,
  useOportunidadeModal,
  type OportunidadeModalItem,
} from '../context/OportunidadeModalContext';

function AutoOpenSheet() {
  const { openModal } = useOportunidadeModal();
  const [params] = useSearchParams();
  const [openedKey, setOpenedKey] = React.useState<string | null>(null);

  React.useEffect(() => {
    const id = params.get('id');
    if (!id) return;

    // Usa toda a querystring como "chave" de inicializaçãƒo.
    // Se a URL mudar (por exemplo, entre info e chart), reabrimos o modal
    // com os novos hints, garantindo que o modo correto seja aplicado.
    const key = params.toString();
    if (openedKey === key) return;

    const symbol = params.get('symbol') || '';
    const name = params.get('name');
    const logoUrl = params.get('logoUrl') || undefined;
    const tf = params.get('tf');
    const mode = params.get('mode');
    const view = params.get('view');

    const item: OportunidadeModalItem = {
      id: String(id),
      symbol: String(symbol || ''),
      name: name || null,
      logo_url: logoUrl,
      kind: 'opportunity',
      chartInitialTimeframe: tf || null,
      // Regras de modo:
      // - view=info  → força modo info (detalhes/contexto)
      // - view=chart → força modo chart
      // - sem view   → compatibilidade: usa apenas o parâmetro mode
      chartForceSignalsOverlay:
        view === 'chart' ? true : view === 'info' ? false : mode === 'chart',
    };

    try {
      openModal(item);
      setOpenedKey(key);
    } catch {
      // noop
    }
  }, [openedKey, openModal, params]);

  return null;
}

export default function MobileOpportunitySheetPage() {
  return (
    <div className="w-full h-[100dvh] bg-background">
      <OportunidadeModalProvider>
        <AutoOpenSheet />
      </OportunidadeModalProvider>
    </div>
  );
}
